import React, { useState } from "react";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import { makeRequest2 } from "../../../utils/makeRequest";
import { toastify } from "../../../utils/toast";
import { addPrivacyPolicyURL } from "../../../utils/urls";

const PrivacyPolicyForm = () => {
    const [policy, setPolicy] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await makeRequest2(addPrivacyPolicyURL, "POST", { content: policy });
            if (response.success) {
                toastify("Privacy Policy saved successfully", "success");
            } else {
                throw new Error(response.error);
            }
        } catch (err) {
            console.error(err);
            toastify("Error saving policy", "error");
        }
    };

    return (
        <div className="container my-5" style={{ maxWidth: "90%" }}>
            <div className="card shadow-sm border-0">
                <div className="card-body">
                    <h4 className="mb-4">Add / Edit Privacy Policy</h4>

                    <ReactQuill
                        theme="snow"
                        value={policy}
                        onChange={setPolicy}
                        placeholder="Write your privacy policy here..."
                        style={{ height: "300px", marginBottom: "60px" }}
                    />

                    <button className="btn btn-primary mt-4" onClick={handleSubmit}>
                        Save Policy
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicyForm;
